import { ApplianceType } from '@vae/server/dist/client'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface EventCardProps {
	appliance: ApplianceType
	saving: number
}

const EventCard: FC<EventCardProps> = ({ appliance, saving }) => {
	const { t } = useTranslation('consumptionElements')
	const { t: ts } = useTranslation('pages_saving', { keyPrefix: 'eventCard' })

	const descriptionText =
		appliance === 'consumption_effect' ? ts('descriptionPlural') : ts('description')

	return (
		<div className='flex flex-row gap-4 h-[4.5rem]'>
			<div className='rounded-lg bg-[#f4f4f4] dark:bg-[#acd7d4] flex items-center justify-center text-base text-brand-secondary-100-light dark:text-brand-primary-200-dark font-semibold aspect-square h-full'>
				{saving.toFixed(2).replace('.', ',')}€
			</div>

			<div className='flex flex-col'>
				<span className='text-text-dark dark:text-white text-lg'>{t(appliance as any)}</span>
				<span className='text-text-grey-200 dark:text-text-grey-100 text-base'>
					{descriptionText}
				</span>
			</div>
		</div>
	)
}

export default EventCard
